import { useHasAccess } from 'lib-shared-access-control';
import { MetaConversation } from 'lib-shared-legacy-types';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { CustomCards } from '../../cards/customCards/customCards';
import type { SidebarMode } from '../../conversationSidebar.types';
import { CardSection } from '../cardSection/cardSection';

type CustomIntegrationCardsProps = {
  metaConversation: MetaConversation;
  isMinimized: boolean;
  sidebarMode: SidebarMode;
  index: number;
};

export const CustomIntegrationCards = ({
  metaConversation,
  isMinimized,
  sidebarMode,
  index,
}: CustomIntegrationCardsProps): JSX.Element | null => {
  const flags = useFeatureFlag(['conversation-right-sidebar-visibility']);

  const hasIntegrationAccess = useHasAccess('conversation.integration');
  if (!hasIntegrationAccess || !flags.conversationRightSidebarVisibility) {
    return null;
  }

  return (
    <CardSection
      title={!isMinimized ? 'Custom integrations' : undefined}
      index={index}
      isMinimized={isMinimized}
    >
      <CustomCards
        isMinimized={isMinimized}
        csid={metaConversation.conversation?.id}
        sidebarMode={sidebarMode}
      />
    </CardSection>
  );
};
